module.exports = __webpack_public_path__ + "static/media/3DPPA33.40c844e7.jpg";